export default __webpack_public_path__ + "static/media/step_8_choose_waste_fraction.7c6ba017.png";